import React, { useEffect, useState, useRef } from 'react';
import db from '../database'
import { Box, FormControl, MenuItem, Select, InputLabel, Typography, Card, CardContent, TextField, Stack, Button } from '@mui/material';
import TagAutoComplete from './TagInput'
import CastTransfer from './castTransfer'
import { useNavigate } from 'react-router-dom';
import ReplacePopup from './replaceDialog';

const styles = {
    indElements : {
        marginBottom:2
    }
}

const FinalDetails = ({finalImg, movie, title, setTitle, context, setContext, setTags, setSelectedCasts, selectedCasts, handleBack, handleSave, setShowReplace}) => {

    if (finalImg) {
        return (
            <Stack direction="column" sx={{padding:2}}>
                <img src={finalImg} width="500" style={{marginBottom:15}}/>
                <TextField sx={styles.indElements} label="Title" value={title} onChange={(e)=>setTitle(e.target.value)}/>
                <FormControl sx={styles.indElements} fullWidth>
                    <InputLabel>Context</InputLabel>
                    <Select
                        value={context}
                        onChange={(e) => setContext(e.target.value)}
                    >
                        <MenuItem value="">None</MenuItem>
                        <MenuItem value="pucham">Pucham</MenuItem>
                        <MenuItem value="shokam">Shokam</MenuItem>
                        <MenuItem value="kalipp">Kalipp</MenuItem>
                        <MenuItem value="shock">Shock</MenuItem>
                        <MenuItem value="pling">Pling</MenuItem>
                        <MenuItem value="thug life">Thug Life</MenuItem>

                    </Select>
                </FormControl>
                <TagAutoComplete setTags={setTags}/>
                <CastTransfer setSelectedCasts={setSelectedCasts} casts={movie.casts} selectedCasts={selectedCasts}/>
                <Stack direction="row" sx={{marginTop:2}} justifyContent="flex-end">
                    <Button onClick={handleBack} variant="outlined">Cancel</Button>
                    <Button onClick={handleSave} sx={{marginLeft:2}} variant="contained">Save</Button>
                    <Button onClick={()=>{setShowReplace(true)}} sx={{marginLeft:2}} variant="contained">Replace</Button>
                </Stack>
            </Stack>
        )
    }
}

const StitchImages = ({chunks, dimensions, height, pattern, movie}) => {
    const hiddenCanvasRef = useRef(null);
    const hiddenSplitCanvasRef = useRef(null);
    const [finalImg, setFinalImg] = useState()
    const [title, setTitle] = useState('')
    const [context, setContext] = useState('')
    const [tags, setTags] = useState([])
    const [selectedCasts, setSelectedCasts] = useState([])
    const [showReplace, setShowReplace] = useState(false);
    const [postId, setPostId]=useState()

    dimensions = movie.dimensions
    const navigate = useNavigate();
    const handleBack = () => {
            navigate(`/movie/${movie._id}`)
    }
    const handleReplace = async() => {
        const token = localStorage.getItem('storedValue')
        const hiddenCanvas = hiddenCanvasRef.current;
        if (token && postId) {
            const body = {
                image: hiddenCanvas.toDataURL('image/jpeg')
            }
            const url = `/api/post/${postId}/image`;
            const opts = {
                    method: "PUT",
                    headers: {
                    "Content-Type": "application/json",
                    "authorization": token 
                    },
                    body: JSON.stringify(body)
                }
            try {
                const response = await fetch(url, opts)
                console.log('>', response.ok)
                if (response.ok) {
                    //const uploaded = await response.json()
                    //console.log(uploaded)
                    navigate(`/movie/${movie._id}`)
                } else {
                    throw response.statusText
                }
            } catch (e) {
                throw e
                console.log(e)
            }
        }
    };
    const handleSave = async() => {
        if (title) {
            const hiddenCanvas = hiddenCanvasRef.current;
            const docToSave = {
                title:title,
                language: movie.language,
                context: context,
                movie: movie.title,
                actors: selectedCasts.map(c=>c.actor),
                characters: selectedCasts.map(c=>c.char),
                tags:tags.map(t=>t.raw),
                _attachments: {
                        image: {
                        content_type: 'image/jpeg',
                        data: hiddenCanvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpeg|jpg);base64,/, ''),
                    },
                }
            }
            try {
                const doc = await db.post(docToSave)
                console.log('>', doc)
                const memes = [...movie.memes, doc.id]
                const movieDoc = {...movie}
                movieDoc.memes = memes
                await db.put(movieDoc)
                navigate(`/movie/${movie._id}`)
            } catch (e) {
                console.log(`error in saving`, e)
            }
        }
    }

    useEffect(() => {
        const saveImg = async() => {
            const hiddenCanvas = hiddenCanvasRef.current;
            const hiddenCtx = hiddenCanvas.getContext('2d');
            const processImg = async () => {
                return new Promise(async (resolve, reject) => {
                hiddenCanvas.height = dimensions.height * parseInt(pattern, 10)
                hiddenCanvas.width = dimensions.width
                for (let i = 0; i < chunks.length; i += 1) {
                    const theImg = chunks[i];
                    if (theImg.isSplit) {
                        const splitCanvas = hiddenSplitCanvasRef.current;
                        const splitCtx = splitCanvas.getContext('2d');
                        splitCanvas.height = movie?.originalDimensions.height;
                        splitCanvas.width = movie?.originalDimensions.width;
                        const applyImg = dir => {
                            return new Promise((innerresolve, innerreject)=> {
                                const _file = dir === 'left' ? theImg.lfile : theImg.rfile
                                //const x = dir === 'left' ? theImg.lfilex - movie?.crop?.left ?? 0 : theImg.rfilex- movie?.crop?.left ?? 0
                                //const offset = dir === 'left' ? 0 : (movie?.originalDimensions?.width/2)
                                const x = dir === 'left' ? (theImg.lfilex - movie?.crop?.left ?? 0) * -1 : theImg.rfilex+ (movie?.crop?.left ?? 0) + movie?.originalDimensions?.width/2
                                const offset = dir === 'left' ? 0 : (movie?.originalDimensions?.width/2)
                                const reader = new FileReader();
                                if (dir=== 'right') {
                                 console.log(x, offset, movie?.originalDimensions, movie.crop, theImg)
                                }
                                reader.onload = (event) => {
                                    const img = new Image();
                                    img.onload = () => {
                                    // Draw the image on the canvas
                                    splitCtx.drawImage(img,
                                        x,
                                        movie?.crop?.top,
                                        movie?.originalDimensions?.width/2,
                                        movie?.originalDimensions?.height,
                                        offset,
                                        0,
                                        movie?.originalDimensions.width/2,
                                        movie?.originalDimensions.height
                                    );
                                        innerresolve()
                                    };
                                    img.src = event.target.result;
                                };
                                reader.readAsDataURL(_file);
                            })
                        }
                        await applyImg('left')
                        await applyImg('right')
                        hiddenCtx.drawImage(
                            splitCanvas,
                            0,
                            0,
                            movie?.originalDimensions?.width,
                            movie.originalDimensions?.height,
                            0,
                            i*dimensions.height,
                            dimensions.width,
                            dimensions.height
                        );
                       // hiddenCtx.drawImage(splitCanvas, 0, movie.crop.top, i*dimensions.height)
                                if (i === chunks.length -1) {
                                    console.log('exit')
                                    resolve()
                                }
                    } else {
                        const reader = new FileReader();
                        reader.onload = (event) => {
                            const img = new Image();
                            img.onload = () => {
                            // Draw the image on the canvas
                                console.log(movie.crop.top+i*dimensions.height, dimensions, movie.originalDimensions)
                                //hiddenCtx.drawImage(img, 0, i*dimensions.height);
                                hiddenCtx.drawImage(img, movie?.crop?.left??0, movie?.crop?.top??0, movie?.originalDimensions?.width, movie?.originalDimensions?.height, 0, i*dimensions.height, dimensions.width, dimensions.height);
                                if (i === chunks.length -1) {
                                    console.log('exit')
                                    resolve()
                                }
                            };
                            img.src = event.target.result;
                        };
                        reader.readAsDataURL(theImg.file);
                    }
                }
            })
        }
   

            await processImg()
            setFinalImg(hiddenCanvas.toDataURL('image/jpeg'))
            //await storeInDb()
        }
        saveImg()
    }, [chunks]);

    return (
        <div>
            <canvas ref={hiddenCanvasRef} style={{display: "none"}}></canvas>
            <canvas ref={hiddenSplitCanvasRef} style={{display:"none"}} ></canvas>
            <FinalDetails 
                finalImg={finalImg}
                title={title}
                setTitle={setTitle}
                context={context}
                setContext={setContext}
                tags={tags}
                setTags={setTags}
                movie={movie}
                selectedCasts={selectedCasts}
                setSelectedCasts={setSelectedCasts}
                handleBack={handleBack}
                handleSave={handleSave}
                setShowReplace={setShowReplace}
            />
            <ReplacePopup open={showReplace} postId={postId} setPostId={setPostId} onClose={()=>{setShowReplace(false)}} process={handleReplace}/>
        </div>
    );
};

export default StitchImages;

